import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';
import Sidebar from '../../components/administracao/Sidebar';
import Navbar from '../../components/administracao/Navbar';
import Footer from '../../components/administracao/Footer';
import { AuthContext } from '../../contexts/AuthContext';
import SwitcherAcervo from '../../components/administracao/SwitcherAcervo';

export default function Admin() {
    const navigate = useNavigate();
    const location = useLocation();
    const auth = useContext(AuthContext);
    const token = auth.getToken();

    // Em telas até 991px o menu lateral vira uma gaveta (ver
    // scss/base/responsivo.scss). Em telas maiores esta classe não tem efeito:
    // o menu continua fixo na lateral como sempre.
    const [menuAberto, setMenuAberto] = useState(false);

    useEffect(() => {
        if (!token) navigate('/login');
    }, [token, navigate]);

    // Trocou de página? Fecha a gaveta, senão ela fica aberta por cima do
    // conteúdo que o usuário acabou de pedir.
    useEffect(() => {
        setMenuAberto(false);
    }, [location.pathname]);

    if (!token) return null;

    return (
        <div className={`admin-layout ${menuAberto ? 'menu-aberto' : ''}`}>
            {/* Navbar isolada no topo */}
            <Navbar />

            <div className="admin-body">
                {/* Sidebar fixo na esquerda */}
                <aside className="admin-sidebar-wrapper">
                    <Sidebar />
                </aside>

                {/* Fundo escurecido: clicar fora fecha a gaveta (só aparece
                    nas telas em que o menu vira gaveta) */}
                <div
                    className="admin-sidebar-backdrop"
                    onClick={() => setMenuAberto(false)}
                    aria-hidden="true"
                />

                {/* Conteúdo principal que NUNCA quebra linha */}
                <main className="admin-main-content">
                    <div className="admin-page-container">
                        <SwitcherAcervo />
                        <Outlet />
                    </div>
                    <Footer />
                </main>
            </div>

            <button
                type="button"
                className="btn-menu-admin"
                onClick={() => setMenuAberto((aberto) => !aberto)}
                aria-label={menuAberto ? "Fechar menu" : "Abrir menu"}
                aria-expanded={menuAberto}
            >
                <FontAwesomeIcon icon={menuAberto ? faXmark : faBars} />
            </button>
        </div>
    );
}
